import { render, staticRenderFns } from "./version-list.vue?vue&type=template&id=9dce6474&scoped=true&"
import script from "./version-list.vue?vue&type=script&lang=ts&"
export * from "./version-list.vue?vue&type=script&lang=ts&"
import style0 from "./version-list.vue?vue&type=style&index=0&id=9dce6474&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dce6474",
  null
  
)

export default component.exports